import React, { Fragment, useState, useMemo, useCallback } from 'react';
import { Table, Form, InputGroup } from '@themesberg/react-bootstrap';
import { FaSearchengin } from 'react-icons/fa';
import { generalNormalize } from '../../utils/functions';

function ListTables({
  data,
  editar,
  messageWd,
  headerAlwaysShow = false,
  hideFirst = false,
}) {
  const [searchText, setSearchText] = useState('');
  const [textFind, setTextFind] = useState(null);

  const searchInTable = useCallback(({ value }) => {
    setSearchText(value);
    if (value.length >= 3) {
      setTextFind(value);
    } else {
      setTextFind(null);
    }
  }, []);

  const filteredData = useMemo(() => {
    if (!textFind) return data;
    return data.filter(row => {
      return Object.values(row)
        .toString()
        .toLowerCase()
        .includes(textFind.toLowerCase());
    });
  }, [data, textFind]);

  const headers = useMemo(() => {
    if (data && data.length > 0) {
      return Object.keys(data[0]);
    }
    return [];
  }, [data]);

  const renderHeaders = () => (
    <thead>
      <tr>
        {headers.map((header, index) => {
          if (hideFirst && index === 0) return null;
          if (header.startsWith('hide_')) return null;
          return <th key={header}>{header}</th>;
        })}
        <th>Acciones</th>
      </tr>
    </thead>
  );

  const getCellStyle = (key, hideTotalMinutes) => {
    if (key === 'Difference') {
      if (hideTotalMinutes >= 1 && hideTotalMinutes < 45) {
        return { backgroundColor: '#ccffcc' }; // Verde pastel
      } else if (hideTotalMinutes >= 45 && hideTotalMinutes < 75) {
        return { backgroundColor: '#ffcc99' }; // Naranja pastel
      } else if (hideTotalMinutes >= 75) {
        return { backgroundColor: '#ff9999' }; // Rojo pastel
      }
    }
    return {};
  };

  const renderRows = () => (
    <tbody>
      {filteredData.map((row, rowIndex) => (
        <tr key={rowIndex}>
          {Object.entries(row).map(([key, value], colIndex) => {
            if (hideFirst && colIndex === 0) return null;
            if (key.startsWith('hide_')) return null;
            const cellStyle = getCellStyle(key, row.hide_total_minutes);
            return (
              <td key={colIndex} style={cellStyle}>
                {generalNormalize(value)}
              </td>
            );
          })}
          <td className="align-middle" style={{ whiteSpace: 'nowrap', width: '1%' }}>{editar(row)}</td>
        </tr>
      ))}
    </tbody>
  );

  if (!data || data.length === 0) {
    return (
      <Table>
        <tbody>
          <tr>
            <td>{messageWd}</td>
          </tr>
        </tbody>
      </Table>
    );
  }

  return (
    <Fragment>
      <Form.Group id="search" className="mt-2">
        <InputGroup>
          <InputGroup.Text>
            <FaSearchengin />
          </InputGroup.Text>
          <Form.Control
            type="text"
            onChange={(e) => searchInTable(e.target)}
            value={searchText}
            placeholder="Buscar . . ."
          />
        </InputGroup>
      </Form.Group>
      <div className={`table-responsive ${headerAlwaysShow ? 'tableFixHead' : ''}`}>
        <Table striped bordered hover className="mt-2">
          {renderHeaders()}
          {renderRows()}
        </Table>
      </div>
    </Fragment>
  );
}

export default ListTables;
